import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 了解渠道
 */
class Channel extends UltMeta {
    IKTOK = new Meta(1, "抖音");
    OFFICIAL_ACCOUNT = new Meta(2, "公众号");
    VIDEO_ACCOUNT = new Meta(3, "视频号");
    FRIEND_SUGGEST = new Meta(4, "朋友推荐");
    WEB_SEARCH = new Meta(5, "网络搜索");
    EXHIBITION_PROMOTION = new Meta(6, "会展推广");
    OTHER = new Meta(7, "其他");
}
export const CHANNEL = new Channel();

/**
 * 意向度
 */
class Intention extends UltMeta {
    HIGH = new Meta(1, "高（准备深度合作）");

    MIDDLE = new Meta(2, "中（合适的机会再合作）");

    LOW = new Meta(3, "低（只是初步了解，目前无合作意向）");
}
export const INTENTION = new Intention();

/**
 * 沟通模块
 */
class CommunicateModule extends UltMeta {
    TRADE = new Meta(1, "商品交易");

    FIND_SHIP = new Meta(2, "找船");

    SAND_PRICE = new Meta(3, "砂价");

    FREIGHT = new Meta(4, "运价");

    QUERY_SHIP = new Meta(5, "查船");

    QUERY_CAR = new Meta(6, "查车");

    FIND_FUNDS = new Meta(7, "找资金");

    INFORMATION = new Meta(8, "资讯");

    XIAO_YUN = new Meta(9, "链小云");
}
export const COMMUNICATE_MODULE = new CommunicateModule();

/**
 * 沟通方式
 */
class CommunicateManner extends UltMeta {
    TELEPHONE = new Meta(1, "电话沟通");

    WECHAT = new Meta(2, "微信沟通");

    SCENE = new Meta(3, "现场拜访");
}
export const COMMUNICATE_MANNER = new CommunicateManner();
